import Swal from 'sweetalert2'

const toast = Swal.mixin({
  // toast: true,
  // position: 'top-end',
  timer: 5000,
  // showConfirmButton: false
})

export default {
  methods: {
    addSuccess (message, onCloseCallBack = null) {
      toast({title: message, type: 'success'})
    },
    addError (message, onCloseCallBack = null) {
      toast({title: message, type: 'error'})
    },
    addInfo (message, onCloseCallBack = null) {
      toast({title: message, type: 'info'})
    },
    addWarning (message, onCloseCallBack = null) {
      toast({title: message, type: 'warning'})
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins.js